import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';
import PageSizeSelector from '../../../../presentation/PageSizeSelector';
import PagePositionLabel from '../../../../presentation/PagePositionLabel';
import Pagination from '../../../../presentation/Pagination';
import NoSearchResults from '../../../../presentation/NoSearchResults';
import LeadgenDeleteDialog from './LeadgenDeleteDialog';
import './css/OffNet.css';

import ReactGrid, 
{ 
  ReactGridHeader,
  ReactGridColumn,
  ReactGridBody,
  ReactGridRowTemplate,
  ReactGridNoRowsTemplate,
  ReactGridReadOnlyCell,
  ReactGridIconCell,
} from '../../../../presentation/ReactGrid';

class LeadGenOffNet extends Component {
  constructor( props ) {
    super( props );
    this.title = 'Leadgen Off Net';
    this._isMounted = false;

    /* Modes Enum */
    this.Modes = {
      NORMAL: 0,
      NEW: 1
    };

    this.state = {
      row: props.row === undefined ? {} : props.row,
      number: '',
      newNumber: '',
      mode: this.Modes.NORMAL,
      dataSource: [],
      pageSize: 25,
      pageIndex: 0,
      deleteDialogShow: false
    };

    // Component Events
    this.fetchData = this.fetchData.bind( this );
    this.fetchNumbersStatus = this.fetchNumbersStatus.bind( this );
    this.onSearchChanged = this.onSearchChanged.bind( this );
    this.onSearchKeyDown = this.onSearchKeyDown.bind( this );
    this.onNewItem = this.onNewItem.bind( this );
    this.onNewItemChanged = this.onNewItemChanged.bind( this );
    this.onSaveItem = this.onSaveItem.bind( this );
    this.onCancelItem = this.onCancelItem.bind( this );

    this.onResetClick = this.onResetClick.bind( this );
    this.onIconClicked = this.onIconClicked.bind( this );
    this.onDeleteAllClick = this.onDeleteAllClick.bind( this );
    this.onRefreshClick = this.onRefreshClick.bind( this );
    this.onPageSizeChanged = this.onPageSizeChanged.bind( this );
    this.onPageChanged = this.onPageChanged.bind( this );

    // Delete Dialog Events
    this.onDeleteAllMatching = this.onDeleteAllMatching.bind( this );
    this.onDeleteDialogCancel = this.onDeleteDialogCancel.bind( this );
    this.onDeleteDialogConfirm = this.onDeleteDialogConfirm.bind( this );
    this.onDeleteRowsDialogConfirm = this.onDeleteRowsDialogConfirm.bind( this );
  }

  componentDidMount( ) {
    this._isMounted = true;
    this.fetchData( );    
  }

  componentWillUnmont() {
    this._isMounted = false;
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( this.title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( this.title, e.statusText , 5000 );
    } else {
      if( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  onSearchChanged( e ) {
    this.setState( { 
      number: e.target.value
    } );
  }

  onSearchKeyDown( e ) {
    if( e.key === 'Enter' ) {
      this.setState( { 
        pageIndex: 0,
      }, () => { 
        this.fetchData( );
      } );
    } 
  }

  onNewItem( ) {
    this.setState( { 
      mode: this.Modes.NEW
    } );
  }

  onNewItemChanged( key, e ) {
    
    if( key === 'NPANXXX' ) { 
      this.setState( { 
        newNumber: e.target.value
      } );
    }

  }

  onSaveItem( ) {
    let newRows = this.state.dataSource;
    
    // // Validate the number 10 digits in length
    if( this.state.newNumber === undefined ) {
      this.setState( { 
        newNumber:'',
        newNumberStatus: 'The new leadgen off net NPANXXX must be at least 1 digit number.'
      } );
      return;
    }

    // Validate the number 10 digits in length
    if( this.state.newNumber.length < 1 ) {
      this.setState( { 
        newNumber:'',
        newNumberStatus: 'The new leadgen off net NPANXXX must be at least 1 digit number.'
      } );
      return;
    }

    // Validate the 10 digit number is not already on list
    if( newRows !== undefined ) { 
      if( newRows.length > 0 ) {
        for( var rowIndex = 0; rowIndex < newRows.length; rowIndex++ ) {
          const row = newRows[ rowIndex ];
          if( row.NPANXXX === this.state.newNumber ) {
            this.setState( { 
              newNumberStatus: 'The new leadgen off net NPANXXX already exists.'
            } );
            return;
          }
        }
      }
    }
    
    const { bugsnag, dispatch } = this.props;
    const row = this.state.row;
    const api = new EtelAPI( 'leadgenoffnet' );
    const alert = new Alerts( bugsnag, dispatch );
    const parameters = {
      LEADGEN_OFF_NET_ID: 0,
      GROUP_NAME: row.GROUP_NAME,
      NPANXXX: this.state.newNumber
    };
    
    api.insert( parameters ).then( ( result ) => { 
      const newRow = result.data[0];
      if( newRow !== undefined ) {
        newRows.unshift( newRow );
      }
      this.setState( { 
        dataSource: newRows,
        newNumber: '',
        newNumberStatus: '',
        mode: this.Modes.NORMAL          
      }, () => { 
        alert.SUCCESS( this.title, 'Successfully saved the new leadgen off net NPANXXX.', 2500 );
      } );
    } ).catch ( ( exception ) => { 
      this.onHandleException( exception );
    } );
  }

  onCancelItem( e ) { 
    this.setState( { 
      newNumber: '',
      newNumberStatus: '',
      mode: this.Modes.NORMAL
    } );
  }


  onResetClick( e ) {
    this.setState( {
      number:'',
    }, () => { 
      this.fetchData();
    } );
  }

  onDeleteAllClick( e ) {
    this.deleteAllMatchNumbers();
  }

  onRefreshClick( e ) {
    this.setState( {
      dataSource: [],
      differences: undefined
    }, () => { 
      this.fetchData( );
    } );
  }

  onPageSizeChanged( pageSize ) {
    this.setState( { 
      pageSize: pageSize
    } );
  }

  onPageChanged( page, e ) {
    this.setState( { 
      pageIndex: page.index
    } );
  }

  onIconClicked( args ) {
    if( args.iconKey === 'delete' ) {
      this.setState( { 
        deletedRow: args.row,
        deleteDialogShow: true
      } );
    }
  }

  onDeleteDialogCancel( ) {
    this.setState( { 
      deleteDialogShow: false
    } );
  }

  onDeleteDialogConfirm( row ) {
    let { dispatch, bugsnag } = this.props;
    let api = new EtelAPI( 'leadgenoffnet' );
    let alert = new Alerts( bugsnag, dispatch );
    let parameters = [
      { LEADGEN_OFF_NET_ID: row.LEADGEN_OFF_NET_ID },
      { GROUP_NAME: row.GROUP_NAME },
      { DEFDNIS: row.DEFDNIS }
    ];
    api.deletemany( parameters ).then( ( result ) => { 
      this.setState( {
        deleteDialogShow: false
      }, () => {
        this.fetchData();
        alert.SUCCESS( this.title, 'Successfully deleted Leadgen Off Net.', 2500 );          
      } );
    } ).catch( ( exception ) => { 
      this.onHandleException( exception );
    } );
  }

  onDeleteAllMatching() { 
    if( this._isMounted === true ) {
      this.setState( { 
        deletedRow: undefined,
        deletedRows: this.state.dataSource,
        deleteDialogShow: true
      } );
    }
  }

  onDeleteRowsDialogConfirm( rows ) {
    const row = this.state.row;
    let { dispatch, bugsnag } = this.props;
    let api = new EtelAPI( 'leadgenoffnet' );
    let alert = new Alerts( bugsnag, dispatch );
    if( row !== undefined && rows.length !== 0 ) {
      let parameters = [
        { LEADGEN_OFF_NET_ID: 0},
        { GROUP_NAME: row.GROUP_NAME },
        { DEFDNIS: row.DEFDNIS },
        { NPANXXX: this.state.number }
      ];
      api.deletemany( parameters ).then( ( result ) => { 
        this.setState( {
          deletedRow: undefined,
          deletedRows: undefined,
          deleteDialogShow: false
        }, () => {
          this.fetchData();
          alert.SUCCESS( this.title, 'Successfully deleted Leadgen Off Net Matched Rows.', 2500 );          
        } );
      } ).catch( ( exception ) => { 
        this.onHandleException( exception );
      } );
    } else {
      alert.WARNING( this.title, 'There is no matching leadgen Off Net to delete.', 2500 );
    }
  }

  fetchRows() { 
    const row = this.state.row;
    let api = new EtelAPI( 'leadgenoffnet' );
    let parameters = [];
    parameters.push( { GROUP_NAME: row.GROUP_NAME } );
    if( ( this.state.number !== undefined ) && ( this.state.number !== '' ) ) {
      parameters.push( { NPANXXX: this.state.number } );
    }
    return new Promise( ( resolve, reject ) => { 
      api.get( parameters ).then( ( results ) => { 
        resolve( results );
      } ).catch( ( exception ) => {  
        reject( exception );
      } );
    } );
  }

  fetchNumbersStatus() {
    let row = this.state.row;
    let api = new EtelAPI( 'ratecall/leadgen/offnet' );
    let parameters = [
      { GROUP_NAME: row.GROUP_NAME }
    ];
    return new Promise( ( resolve, reject ) => {
      api.get( parameters ).then ( ( results ) => {
        if( results.length === 1 ) {
          resolve( results[0] );
        } else {
          resolve( { 'RESULT':'No Results Returned.' } );
        }
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  fetchData( ) { 

    if( this._isMounted === true ) {

      let fetchRows = ( ) => {
        return this.fetchRows();
      };
  
      let fetchNumbersStatus = ( ) => {
        return this.fetchNumbersStatus( );
      };
  
      let handleException = ( exception ) => { 
        this.onHandleException( exception );
      };
  
      const LEADGEN_OFF_NET_ROWS_INDEX = 0;
      const LEADGEN_OFF_NET_DIFFERENCES_INDEX = 1;
      Promise.all( [ fetchRows(), fetchNumbersStatus() ] ).then( ( results ) => {
        const rows = results[ LEADGEN_OFF_NET_ROWS_INDEX ];
        const differences = results[ LEADGEN_OFF_NET_DIFFERENCES_INDEX ];
        this.setState( {
          dataSource: rows,
          differences: differences
        } );
      } ).catch( ( exception ) => { 
        handleException( exception );
      } );
    }
  }

  getPageSizeOptions() { 
    let options = [];
    const dataSource = this.state.dataSource;

    if( dataSource === undefined ) {
      return options;
    }

    if( dataSource === null ) {
      return options;
    }
    
    if( dataSource.length >= 25 ) {
      options.push( { value: 25, selected: true } );
    }

    if( dataSource.length >= 50 ) {
      options.push( { value: 50, selected: false } );
    }

    if( dataSource.length >= 75 ) {
      options.push( { value: 75, selected: false } );
    }

    if( dataSource.length >= 100 ) {
      options.push( { value: 100, selected: false } );
    }

    if( dataSource.length >= 500 ) {
      options.push( { value: 500, selected: false } );
    }

    if( dataSource.length >= 1000 ) {
      options.push( { value: 1000, selected: false } );
    }

    return options;
  }

  onRenderNumbersStatus() {
    const differences = this.state.differences;
    let renderedStatus = [];
    let pageSizeSelectorControl = '';

    if( this.state.dataSource !== undefined ) {
      if( this.state.dataSource.length > 0 ) {
        if( this.state.dataSource.length >= this.state.pageSize ) {
          pageSizeSelectorControl = (
            <PageSizeSelector options={this.getPageSizeOptions()} onPageSizeChanged={this.onPageSizeChanged} /> 
          );
        }
      }
    }

    if( differences !== undefined ) {

      renderedStatus.push( 
        <span key="leadgen-off-net-status-cell-1" className="leadgen-off-net-status-cell-1">
          <label>
            {unescape( differences.RESULT )}
          </label>
          <button key="leadgen-off-net-status-refresh-button" className="dialog-save-button" style={ { 'marginLeft':'10px' } } onClick={this.onRefreshClick}>
            Refresh
          </button>
        </span>
      );

      renderedStatus.push( 
        <span key="leadgen-off-net-status-cell-2" className="leadgen-off-net-status-cell-2">
          {pageSizeSelectorControl}
        </span>
      );

      return renderedStatus;
    }
    return 'Please wait checking numbers...';
  }

  onRenderHeader() { 

    let renderedControls = [];
    
    if( this.state.mode === this.Modes.NORMAL ) {

      // Search Label
      renderedControls.push(
        <span key="leadgen-off-net-header-cell-1" className="leadgen-off-net-header-cell-1">
          <label>
              Search NPANXXX (Use %)
          </label>
        </span>        
      );

      // Search Input
      renderedControls.push(
        <span key="leadgen-off-net-header-cell-2" className="leadgen-off-net-header-cell-2">
          <input 
            key="leadgen-off-net-search-input" 
            type="text" 
            value={this.state.number} 
            onChange={this.onSearchChanged}
            onKeyDown={this.onSearchKeyDown} 
          />
          <button 
            key="leadgen-off-net-search-delete-all-matching-button" 
            onClick={this.onDeleteAllMatching} 
            className="dialog-delete-button" 
            style={{'width':'250px'}}>
            Delete ALL Matching 
          </button>
        </span>
      );

      // New Leadgen Off Net Button
      renderedControls.push(
        <span key="leadgen-off-net-header-cell-3" className="leadgen-off-net-header-cell-3">
          <button
            key="leadgen-off-net-new-button"
            onClick={this.onNewItem}
          >
            New Off Net Number
          </button>
        </span>
      );
    }

    if( this.state.mode === this.Modes.NEW ) {

      // Search Label
      renderedControls.push(
        <span key="leadgen-off-net-header-cell-1" className="leadgen-off-net-header-cell-1">
          <label>
              NPAXX
          </label>
        </span>        
      );

      // Search Input
      renderedControls.push(
        <span key="leadgen-off-net-header-cell-2" className="leadgen-off-net-header-cell-2">
          <input 
            key="leadgen-off-net-search-input" 
            type="text" 
            value={this.state.newNumber} 
            onChange={this.onNewItemChanged.bind( this, 'NPANXXX' )}
          />
          <button
            key="leadgen-off-net-new-button"
            onClick={this.onSaveItem}
          >
            Save
          </button>
          <button
            key="leadgen-off-net-cancel-button"
            onClick={this.onCancelItem}
          >
            Cancel
          </button>
        </span>
      );

      // New Leadgen Number Button
      renderedControls.push(
        <span key="leadgen-off-net-header-cell-3" className="leadgen-off-net-header-cell-3">
          <label>
            {this.state.newNumberStatus}
          </label>
        </span>
      );
    }

    return renderedControls;
  }

  onRenderBody() { 
    let pageSize = this.state.pageSize;
    const pageTotal = this.state.dataSource === undefined ? 0 : this.state.dataSource.length;
    let spacerWidth = ( pageTotal > pageSize ) ? '33px' : '50px';
    return (
      <ReactGrid 
        tagName="grid" 
        dataSource={this.state.dataSource}
        paging={true}
        pageSize={this.state.pageSize}
        pageIndex={this.state.pageIndex}
        onIconColumnClicked={this.onIconColumnClicked}
        onIconClicked={this.onIconClicked}
        height="55vh"
        width="78.5vw"
      >
        <ReactGridHeader tagName="header">
          <ReactGridColumn
            tagName='column' 
            caption='GROUP NAME'
            width='300px'
            dataType='string'
            index={0}
          />          
          <ReactGridColumn
            tagName='column' 
            caption='DEFDNIS'
            width='150px'
            dataType='string'
            index={1}
          />          
          <ReactGridColumn
            tagName='column' 
            caption='NPANXXX'
            width='150px'
            sorted='NPANXXX'
            dataType='string'
            index={2}
          />
          <ReactGridColumn
            index={3}
            tagName='column' 
            caption='Delete'
            width='100px'
            icon='icon-fontello-trash-8'
            tooltip='Delete ALL Matching Rows'
          />
          <ReactGridColumn
            index={4}
            tagName='column' 
            caption=''
            width={'50px'}
          />
        </ReactGridHeader>
        <ReactGridBody tagName="body">
          <ReactGridRowTemplate tagName='rowTemplate'>
            <ReactGridReadOnlyCell 
              tagName='readOnlyCell'
              column='GROUP_NAME'
              width='300px'
              align='left'
            />
            <ReactGridReadOnlyCell 
              tagName='readOnlyCell'
              column='DEFDNIS'
              width='150px'
              align='center'
            />                
            <ReactGridReadOnlyCell 
              tagName='readOnlyCell'
              column='NPANXXX'
              width='150px'
              align='center'
            />
            <ReactGridIconCell 
              tagName='iconCell'
              width='100px'
              align='center'
              icon='icon-fontello-trash-8'
              iconKey='delete'
              iconColor='#BE000E'
            />
            <ReactGridReadOnlyCell
              tagName='readOnlyCell'
              column=''
              width={spacerWidth}
            />
          </ReactGridRowTemplate>  
          <ReactGridNoRowsTemplate tagName='noRowTemplate' height='50px'>
            <NoSearchResults caption='There are no leadgen off net number results' />
          </ReactGridNoRowsTemplate>          
        </ReactGridBody>
      </ReactGrid>              
    );
  }
  
  onRenderFooter() { 
    let pageSize = this.state.pageSize;
    const pageStart = ( parseInt( this.state.pageIndex, 10 ) * parseInt( pageSize, 10 ) ) + 1;
    const pageEnd = pageStart + parseInt( pageSize, 10 ) - 1;
    const pageTotal = this.state.dataSource === undefined ? 0 : this.state.dataSource.length;
    let renderedControls = [];
    
    renderedControls.push( 
      <span key="leadgen-off-net-footer-cell-1" className="leadgen-off-net-footer-cell-1">
        <PagePositionLabel pagesize={pageSize} pagestart={pageStart} pageend={pageEnd} pagetotal={pageTotal} />
      </span>
    );

    renderedControls.push(
      <span key="leadgen-off-net-footer-cell-2" className="leadgen-off-net-footer-cell-2">
        <Pagination pageindex={this.state.pageIndex} totalitems={pageTotal} maxitemsperpage={this.state.pageSize} maxpages={6} onPageChanged={this.onPageChanged} />
      </span>
    );

    return renderedControls;
  }
  
  render( ) {

    let deleteDialog = '';
    if( this.state.deletedRow !== undefined ) {
      deleteDialog = (
        <LeadgenDeleteDialog 
          caption='Delete Off Net' 
          message={'Are you sure you want to delete leadgen off net ' + this.state.deletedRow.NPANXXX + '?'}
          show={this.state.deleteDialogShow} 
          onCancel={this.onDeleteDialogCancel} 
          onConfirm={this.onDeleteDialogConfirm} 
          row={this.state.deletedRow}
        />
      );
    } else if( this.state.deletedRows !== undefined ) {
      deleteDialog = (
        <LeadgenDeleteDialog 
          caption='Delete Off Net Numbers' 
          message={'Are you sure you want to delete ' + this.state.deletedRows.length + ' leadgen off net numbers matched?'}
          show={this.state.deleteDialogShow} 
          onCancel={this.onDeleteDialogCancel} 
          onConfirm={this.onDeleteRowsDialogConfirm} 
          rows={this.state.deletedRows}
        />
      );
    }

    return (
      <span className="leadgen-off-net">
        <span className="leadgen-off-net-status">
          {this.onRenderNumbersStatus()}
        </span>
        <span className="leadgen-off-net-header">
          {this.onRenderHeader()}
        </span>
        <span className="leadgen-off-net-body">
          {this.onRenderBody()}
        </span>
        <span className="leadgen-off-net-footer">
          {this.onRenderFooter()}
        </span>
        {deleteDialog}
      </span>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( LeadGenOffNet ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/leadgen/components/LeadGenOffNet.js